import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { List, ListItem, ListItemText, ListItemIcon } from '@pwc/appkit-react/lib/List';
import { Progress } from '@pwc/appkit-react/lib/Progress';

import { ARCHIVE_EXPORT } from '@common/constants/batchReportsConstants';

import { jobsSelector } from '../../shared/jim/store/selectors';
import { JobPropType } from '../../shared/jim/propTypes';
import { statuses } from '../../shared/jim/constants';

import FailedJob from './failedJob.component';
import SucceededExportJob from './succeededExportJob.component';
import { getJobProgress } from '../../shared/jim/helpers';
import { isExportTypeJob } from './helpers';

const JobsList = ({
  jobs,
  openModal,
}) => (
  <List className="jobs-list">
    {jobs.map(job => {
      if (job.status === statuses.Failed) {
        return (
          <div key={job.jobId} className="list-item-wrapper">
            <FailedJob job={job} openModal={openModal} />
          </div>
        );
      }
      if (job.status === statuses.Success) {
        return isExportTypeJob(job)
          ? (
            <div key={job.jobId} className="list-item-wrapper">
              <SucceededExportJob
                job={job}
                isZipFile={job.jobType === ARCHIVE_EXPORT}
              />
            </div>
          ) : (
            <div key={job.jobId} className="list-item-wrapper">
              <ListItem>
                <ListItemText> {job.displayName} </ListItemText>
                <ListItemIcon
                  className="ml-auto text-success"
                  icon={<span className="appkiticon icon-circle-checkmark-outline" />}
                />
              </ListItem>
            </div>
          );
      }

      return (
        <div key={job.jobId} className="list-item-wrapper">
          <ListItem>
            <ListItemText> {job.displayName} </ListItemText>
            <ListItemIcon
              className="ml-auto"
              icon={<span className="appkiticon icon-setting-outline icon-rotating" />}
            />
            <br />
          </ListItem>
          <div className="progress-bar-wrapper">
            <Progress percent={getJobProgress(job)} />
            <div className="progress-bar-value">
              {getJobProgress(job).toFixed(0)}%
            </div>
          </div>
        </div>
      );
    })}
  </List>
);

JobsList.propTypes = {
  jobs: PropTypes.arrayOf(JobPropType).isRequired,
  openModal: PropTypes.func.isRequired,
};

export default connect(state => ({
  jobs: jobsSelector(state),
}))(JobsList);
